import React, {Component,useState} from 'react';
import axios from 'axios';
import * as ReactBootStrap from 'react-bootstrap';
import '../tools/css/Servicios.css';

import emptypage from '../tools/images/carpeta.gif';

import Especialidad from '../API/Especialidad';

import BtnEdit from '../components/BtnEdit';
import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

import Select from 'react-select';
import Moment from 'react-moment';
import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';


const ApiURL="https://medicall-api-test.azurewebsites.net";

var institution_id =sessionStorage.getItem('id_institution');
var token_institucion =sessionStorage.getItem('token');
var url_iframe="https://acsc.appideas.com.co/servicios?token="+token_institucion

class Servicios_facturacion extends Component {

  constructor()
    {
     super()
      this.state={
        show:false,
        profe: '',
        Servicios:[] ,
        Cups:[] ,
        loading: false,
        loading_button: true,
        active_button: true,
        form:{   
          cod_servi:'',  
          nom_servi:'',   
          descrip:'',
          valor_servi:'',
          id_servi_edit:'',
          cod_servi_edit:'',  
          nom_servi_edit:'',   
          descrip_edit:'',
          valor_servi_edit:''
          }     
              
      }      
      
    }

   
  

    render(){     
     const {form} = this.state;

     return (    

     
      <div className="content-wrapper">

                   <div className="m24-iframe-fill">
                     <iframe
                      title="Facturacion"
                      src={url_iframe}
                      loading="lazy"
                      allowFullScreen
                      >
                     </iframe>
                   </div>

      </div>
      
    )

  }
  
}


export default Servicios_facturacion;